 
/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, inject, Injectable, signal } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Device } from '@data/models';
@Injectable({
  providedIn: 'root',
})
export class DeviceInfoService {
  private platform = inject(Platform);
  private deviceService = inject(DeviceDetectorService);

  private _deviceInfo = signal<Device>({
    coordenada: null,
    host: window?.location?.origin || null,
    browser: null,
    dispositivo: this.getPlatformName(),
    so: this.getOS(),
  });

  readonly deviceInfo = computed<Device>(() => this._deviceInfo());

  setDeviceInfo(data: Device) {
    this._deviceInfo.set(data);
  }

  getPlatformName(): string {
    return this.deviceService.isMobile() || this.deviceService.isTablet() ? 'movil' : 'web';
  }

  async getBrowserName(): Promise<string> {
    const agent = window.navigator.userAgent.toLowerCase();
    if (((navigator as any)?.brave && (await (navigator as any)?.brave?.isBrave())) || false) {
      return 'Brave';
    }
    if (agent.includes('opr') && !!(window as any)?.opr) {
      return 'Opera';
    }
    if (agent.includes('chrome') && !!(window as any)?.chrome) {
      return 'Chrome';
    }
    if (this.platform.FIREFOX) {
      return 'Firefox';
    }
    if (this.platform.EDGE) {
      return 'Edge';
    }
    if (this.platform.SAFARI) {
      return 'Safari';
    }
    if (this.platform.TRIDENT) {
      return 'IE';
    }
    return 'Otro';
  }
  getOS(): string {
    if (this.platform.ANDROID) {
      return 'Android';
    }
    if (this.platform.IOS) {
      return 'IOS';
    }
    if (this.deviceService.os) {
      return this.deviceService.os;
    }
    return 'Otro';
  }
}
